import React from 'react';
import {Typography} from '~library/atoms/Typography';
import {Range} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/components/Range/Range';
import {useImageSize} from '~/CreateFabricInvitation/components/PhotoEditor/common/useImageSize';
import {useImageSizeLimits} from '~/CreateFabricInvitation/components/PhotoEditor/common/useImageSizeLimits';
import {
  MIN_IMAGE_SIZE,
  MAX_IMAGE_SIZE,
} from '~/CreateFabricInvitation/components/PhotoEditor/constants/imageSizeLimits';

export const SizeControl = ({canvas, processing}) => {
  const {scaleValue, setImageScale} = useImageSize();

  useImageSizeLimits(canvas, {min: MIN_IMAGE_SIZE, max: MAX_IMAGE_SIZE});

  return (
    <div className="uyo-control-slider-container">
      <Typography variant="list1" classNames="uyo-control-slider-label">
        Size
      </Typography>
      <div className="uyo-control-slider">
        <Range
          min={0.1}
          max={2}
          step={0.1}
          value={scaleValue}
          onChange={setImageScale}
          onLocalChange={setImageScale}
          hasControls
          hiddenInput
          dataQaId="size-slider"
          disabled={processing}
        />
      </div>
    </div>
  );
};
